import axios from "axios";

export const getNorwayData = async (query) => {
  query = query.replaceAll("&", " ");
  const params = {
    navn: query,
  };
  try {
    let data = await axios.get(
      `${process.env.REACT_APP_COMPANY_LOOKUP_BASE_URL}/searchNorwayCompany`,
      {
        params,
      }
    );
    if (!data?.data?._embedded) return [];
    data = data?.data?._embedded?.enheter;
    if (data === "No Search result found") return [];
    const finalData = [];
    for (const item of data) {
      const { organisasjonsnummer, navn, forretningsadresse } = item;
      if (forretningsadresse) {
        var { adresse, land, postnummer } = forretningsadresse;
      }
      const obj = {
        companyNumber: organisasjonsnummer,
        companyName: navn,
        companyAddress: adresse ? `${adresse[0]} ${land} ${postnummer}` : null,
      };
      finalData.push(obj);
    }
    return finalData;
  } catch (error) {
    return error;
  }
};
